import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { KoanBusinessCardStackBackgroundViewModel } from './koan-business-card-stack-background-view-model';
import { CardBackgroundComponent } from '../../card-background.component';

@Component({
  selector: 'app-koan-business-card-stack-background',
  templateUrl: './koan-business-card-stack-background.component.html',
  styleUrls: ['./koan-business-card-stack-background.component.scss'],
  providers: [KoanBusinessCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class KoanBusinessCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public override viewModel: KoanBusinessCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
